import ContentNotFoundRoot from '../../components/pages/ContentNotFound';
import { FullHeightOnly } from '../../components/shared/Grid';
import TemplateCenter from '../../layout/TemplateCenter';

const NotFound = () => {
  return (
    <TemplateCenter>
      <FullHeightOnly>
        <ContentNotFoundRoot />
      </FullHeightOnly>
    </TemplateCenter>
  );
};

export default NotFound;
